import { ShoppingBag, Bike } from "lucide-react";
import { Reveal } from "./Reveal";

const money = (n) => `$${Number(n).toFixed(2).replace(/\.00$/, "")}`;

export default function TakeawayBoard({ takeaway, onOrder }) {
  const items = takeaway?.items || [];
  return (
    <Reveal className="w-full">
      <div
        data-testid="takeaway-board"
        className="h-full chalkboard rounded-3xl border-4 border-[#d9cdb8] shadow-brutal-lg p-6 md:p-8 flex flex-col"
      >
        <div className="text-center">
          <p className="font-chalk text-2xl text-[#efe8d8]/80 leading-none">Fresh from the kitchen</p>
          <h3 className="font-chalk font-bold text-5xl md:text-6xl leading-none mt-1">Takeaway</h3>
          <div className="flex items-center justify-center gap-4 mt-2 font-chalk text-2xl text-[#efe8d8]/90">
            <span className="inline-flex items-center gap-1.5"><ShoppingBag size={18} /> Pick up</span>
            {takeaway?.delivery_enabled && (
              <span className="inline-flex items-center gap-1.5"><Bike size={18} /> Delivery</span>
            )}
          </div>
        </div>

        <ul className="mt-6 space-y-2.5 flex-1">
          {items.map((it) => (
            <li key={it.id} data-testid={`takeaway-line-${it.id}`} className="flex items-end gap-2 font-chalk">
              <span className="text-2xl md:text-3xl leading-none">{it.name}</span>
              <span className="flex-1 chalk-leader translate-y-[-6px]" />
              <span className="text-2xl md:text-3xl leading-none">{money(it.price)}</span>
            </li>
          ))}
          {!items.length && (
            <li className="font-chalk text-2xl text-center text-[#efe8d8]/70">Menu coming soon…</li>
          )}
        </ul>

        <button
          onClick={onOrder}
          data-testid="takeaway-order-btn"
          className="mt-6 w-full font-head font-extrabold text-lg bg-[#f5f3de] text-[#1f2a26] border-2 border-[#1f2a26] rounded-full py-3.5 hover:translate-y-[2px] transition-transform"
        >
          Order Takeaway
        </button>
      </div>
    </Reveal>
  );
}
